import { Button } from '@/components/ui/button';
import { Card, CardContent } from '@/components/ui/card';
import { ConnectionDetail } from './connection-detail';
import { Separator } from '@/components/ui/separator';
import { ConnectionDetailProps } from '@/lib/types';

interface IntegrationCardProps {
  title: string;
  description: string;
  logo: string;
  isEnabled: boolean;
  connectData: ConnectionDetailProps | undefined;
  onToggle: (checked: boolean) => void;
  comingSoon?: boolean;
}

export const IntegrationCard = ({
  title,
  description,
  logo,
  isEnabled,
  connectData,
  onToggle,
  comingSoon,
}: IntegrationCardProps) => {
  return (
    <Card className={`rounded-lg border bg-white ${comingSoon ? 'opacity-60' : ''}`}>
      <CardContent className='flex flex-col space-y-3 px-4 py-4'>
        {/* Row 1: Icon, Title, Connect Button */}
        <div className='flex justify-between items-center w-full'>
          <div className='flex items-center space-x-3'>
            <div className='w-10 h-10 relative flex-shrink-0'>
              <img src={logo} alt={`${title} logo`} className='size-full object-contain' />
            </div>
            <h3 className='text-base font-medium text-gray-900'>{title}</h3>
            {comingSoon && (
              <span className='inline-flex items-center px-2 py-0.5 rounded-full text-xs font-medium bg-gray-100 text-gray-600'>
                Coming Soon
              </span>
            )}
          </div>
          {!comingSoon && (
            <Button
              size="sm"
              variant="default"
              onClick={() => onToggle(!isEnabled)}
            >
              {isEnabled ? 'Manage' : 'Connect'}
            </Button>
          )}
        </div>
        {/* Row 2: Description */}
        <p className='text-sm text-gray-500'>{description}</p>
        {connectData && connectData !== undefined && (
          <>
            <Separator />
            <ConnectionDetail
              connectedDate={connectData.connectedDate}
              accountId={connectData.accountId}
              apiKey={connectData.apiKey}
              serviceName={connectData.serviceName}
            />
          </>
        )}
      </CardContent>
    </Card>
  );
};
